import { sbaAxios } from "../utils/sbaAxios";
import { getEmailrule, getEmailAttachmentSecurity} from "../../config/apiConfig";
import {
    FETCH_EMAILRULES_BEGIN,
  FETCH_EMAILRULES_SUCCESS,
    FETCH_EMAILRULES_FAILURE,

    FETCH_EMAILRULESATTACHEMENT_BEGIN,
    FETCH_EMAILRULESATTACHEMENT_SUCCESS,
    FETCH_EMAILRULESATTACHEMENT_FAILURE 
  } from '../constants/emailRules';


export const getEmailRules=  (EmailruleTypeId,EmailruleId,activeOnly)=> {
   return  (dispatch) => {
       dispatch(fetchEmailRulesBegin());
       sbaAxios({
           url: `${getEmailrule}${EmailruleTypeId}?&emailruleId=${EmailruleId}&activeOnly=${activeOnly}`,
           method: 'get',
       })
      .then((repos) => {
        const ListemailRules = repos;
        dispatch(fetchEmailRulesSuccess(ListemailRules));
        return ListemailRules;
      })
      .catch((error) =>{ return dispatch(fetchEmailRulesFailure(error))});
  };
}

export const fetchEmailRulesBegin = () => ({
  type: FETCH_EMAILRULES_BEGIN,
});

export const fetchEmailRulesSuccess = (emailRules) => ({
  type: FETCH_EMAILRULES_SUCCESS,
  payload: {emailRules},
});


export const fetchEmailRulesFailure = (errorMessage) => ({
  type: FETCH_EMAILRULES_FAILURE,
  payload: {errorMessage}
});


export const getEmailAttachmentSecurityAction = (EmailsecurityId) => {
    return (dispatch) => {
        dispatch(fetchEmailAttachmentSecurityBegin());
        sbaAxios({
            url: `${getEmailAttachmentSecurity}?emailAttachmentSecurityId=${EmailsecurityId}`,
            method: 'get',
        })
            .then((repos) => {
                const AttachmentSecurity = repos;
                dispatch(fetchEmailAttachmentSecuritySuccess(AttachmentSecurity));
                return AttachmentSecurity;
            })
            .catch((error) => { return dispatch(fetchEmailAttachmentSecurityFailure(error)) });
    };
}

export const fetchEmailAttachmentSecurityBegin = () => ({
    type: FETCH_EMAILRULESATTACHEMENT_BEGIN,
});

export const fetchEmailAttachmentSecuritySuccess = (AttachmentSecurity) => ({
    type: FETCH_EMAILRULESATTACHEMENT_SUCCESS,
    payload: { AttachmentSecurity },
});


export const fetchEmailAttachmentSecurityFailure = (errorMessage) => ({
    type: FETCH_EMAILRULESATTACHEMENT_FAILURE,
    payload: { errorMessage }
});

